<template>
    <el-row :gutter="30"  class="mw-100 manage-partner" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentPartnerData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addPartnerRef"
                            :model="currentPartnerData"
                            :rules="currentPartnerDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                                <el-col :lg="24" :xs="24">
                                    <el-form-item>
                                        <el-button type="primary" @click="managePartner('addPartnerRef',index)" class="text-cap">
                                            <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                            save
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="3" :xs="24">
                                    <el-form-item  label="partner order" prop="order">
                                        <el-input type="text" v-model="currentPartnerData.seq"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :xs="24">
                                    <el-form-item  label="partner image" prop="imageBase64">
                                        <el-image 
                                            style="width: 150px; height: 150px;margin-right:20px" 
                                            :src="isAddPartner ? currentPartnerData.imageURL :  $getImage(currentPartnerData.imageURL) || ''" 
                                            fit="cover"
                                            :zoom-rate="1.2"
                                            :preview-src-list="[isAddPartner ? currentPartnerData.imageURL : $getImage(currentPartnerData.imageURL)]"
                                            :preview-teleported="true"
                                        >
                                            <template #error>
                                                <div class="image-slot">
                                                    <font-awesome-icon :icon="['fas', 'image']" />
                                                </div>
                                            </template>
                                        </el-image>
                                        <el-upload
                                            ref="imageBase64"
                                            action="#"
                                            :auto-upload="false"
                                            :on-change="onUploadImage"
                                            :disabled="fileUploaded"
                                            :on-remove="handleRemoveImage"
                                            accept="image/png, image/jpeg,image/gif"
                                            class="font-24 d-flex align-center flex-1"
                                        >
                                            <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentPartnerData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <!-- <el-input type="textarea" rows="4" v-model="currentPartnerData.translates[index].description"></el-input>     -->
                                        <ckeditor class="w-100" :editor="editor" v-model="currentPartnerData.translates[index].description" :config="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? editorConfigAr :editorConfig "></ckeditor>  
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="brands">
                                         <el-upload
                                            v-model:file-list="fileList"
                                            ref="uploadBrandRef"
                                            action="#"
                                            :auto-upload="false"
                                            list-type="picture-card"
                                            :on-change="onUploadBrand"
                                            :on-preview="handlePictureCardPreview"
                                            :on-remove="handleRemove"
                                        >
                                            <font-awesome-icon :icon="['fas', 'plus']" style="width:20px" class="color-brown" />
                                        </el-upload>    
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    <el-dialog v-model="dialogVisible" width="30%">
        <img w-full :src="dialogImageUrl" alt="Preview Image" class="w-100" />
    </el-dialog>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    data(){
        return {
            currentPage:[],
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
               
                // The configuration of the editor.
            },
            editorConfigAr: {
                language: {
                    // The UI will be English.
                    ui: 'ar',

                    // But the content will be edited in Arabic.
                    content: 'ar'
                }
            },
            fileList:[],
            isAddPartner:true,
            dialogVisible:false,
            dialogImageUrl:'',
            currentPartner:[],
            fileUploaded:false,
            currentPartnerData:{},
            currentPartnerDataRules:{
                translates:this.$setTranslateRules(['description','title']),
            }
        };
    },
    computed:{
        cachedPartner(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.partners?.currentPartner || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedPartner.id) {
            this.isAddPartner = false;
            this.currentPartnerData = JSON.parse(JSON.stringify(this.cachedPartner));
            this.currentPartnerData = this.converUpdatedObj(this.currentPartnerData);
            this.currentPartnerData.translates = this.$filterPublishedTranslates(this.currentPartnerData.translates);
            this.currentPartnerData.active = true;
            this.fileList = this.currentPartnerData.subItems.map(img => {
                return {
                    name:'oldItem',
                    uid:img.id,
                    url:this.$getImage(img.imageURL)
                }
            });
        }else{
            this.$router.push({
                name:'manage-partner',
            })
            this.isAddPartner = true;
            this.currentPartnerData = this.initState()
            this.currentPartnerDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
        }
    },
    
    methods:{
        initState(){
            return {
                id:-1,
                subItems:[],
                translates:this.$setTranslateKeys({
                    'description':'',
                    'title':'',
                })
            }
        },
      
        async managePartner(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addPartnerRef'].length){
                            this.managePartnerAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async managePartnerAfterValidate(){
            let clonedData = JSON.parse(JSON.stringify(this.currentPartnerData));
            delete clonedData.imageURL;
            
            let newSubItems =[];
            clonedData.subItems.forEach(item =>  {
                if (item.uid != undefined){
                    delete item.imageURL;
                    delete item.uid;
                    newSubItems.push(item)
                }
            })
           
            clonedData.subItems = newSubItems;
            
            const response = await this.$store.dispatch(this.isAddPartner ? 'addPartner':'editPartner',clonedData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllPartners');
                this.$router.push({
                    name:'partners-list'
                })
            }
        },
       
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentPartnerData.imageBase64 = evt.target.result;
                }); 
                this.currentPartnerData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
            
        }, 
        handleRemoveImage(){
            this.currentPartnerData.imageURL = this.isAddPartner ? '' : this.cachedPartner.imageURL
        },   
        handlePictureCardPreview(file){
            this.dialogVisible = true;
            this.dialogImageUrl = file.url;

        },
        handleRemove(file){
            let imageIndexFromSubITems;
            if(file.name  == 'oldItem') {
                imageIndexFromSubITems = this.currentPartnerData.subItems.findIndex(img => img.id == file.uid);
                this.currentPartnerData.subItems[imageIndexFromSubITems].active = false;
                this.currentPartnerData.subItems[imageIndexFromSubITems].uid = file.uid;
            }else{
                imageIndexFromSubITems = this.currentPartnerData.subItems.findIndex(img => img.uid == file.uid);
                this.currentPartnerData.subItems.splice(imageIndexFromSubITems,1);
            }
        },
        onUploadBrand(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
        
                let indexToRemove = this.fileList.findIndex(fl => fl.uid == file.uid)
                this.fileList.splice(indexToRemove,1)
                
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentPartnerData.subItems.push({
                        imageBase64:evt.target.result,
                        seq:0,
                        uid:file.uid,
                        id:-1,
                    });
                }); 
                // this.currentPartnerData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },
        converUpdatedObj(oldObj){
            // Copy the object
            let newObj = Object.assign({}, oldObj);
            delete newObj.value;
            delete newObj.image2URL;
            return newObj
            
        }
    }
}
</script>
<style lang="scss">
    .manage-partner {
        .ck-editor {
            width:100%;
        }
    }
</style>